import { NgModule } from '@angular/core';
import { LimitToPipe } from './limit-to.pipe';

@NgModule({
    declarations: [LimitToPipe],
    exports: [LimitToPipe],
})
export class LimitToPipeModule {}
